import { ResponseType } from 'axios';

import axiosInstance from 'src/api/instance';

export const getExternal = (url: string, responseType: ResponseType, params?: any) =>
  axiosInstance.request({ method: 'GET', url, responseType, params });
